import { Input, Search } from 'components/ui';
import {
  SAutocomplete,
  SAutocompleteLabel,
  SAutocompleteWrapper,
  SContainer,
} from './styled';
import { useTranslation } from 'react-i18next';
import FilterButton from 'components/ui/FilterButton';
import { KeyboardArrowDown } from '@mui/icons-material';
import { NewPatientButton, ImportButton } from '../components';
import getPermission from 'lib/utils/getPermission';
import { useSelector } from 'react-redux';
import { selectors as authSelectors } from 'services/auth';

export default function PatientsListFilterBar({
  filterName,
  onSearch,
  onFilterButtonClick,
  openNewPatientDialog,
  openImportPaitentDialog,
}) {
  const { t } = useTranslation();
  const isINS = useSelector(authSelectors.getIsINS);

  return (
    <SContainer>
      <div style={{ display: 'flex', alignItems: 'center', gap: 10 }}>
        <Search
          placeholder={t('Search patients')}
          value={filterName}
          onChange={onSearch}
          data-id="search-patients"
          boxStyle={{ width: '300px' }}
        />
        <FilterButton onClick={() => onFilterButtonClick((curr) => !curr)} />
        <SAutocompleteWrapper>
          {/* DO NOT DELETE */}
          {/* <SAutocompleteLabel>{t('Sort by') + ': '}</SAutocompleteLabel> */}
          {/* <SAutocomplete
            options={[]}
            popupIcon={<KeyboardArrowDown />}
            renderInput={(params) => <Input {...params} />}
          /> */}
        </SAutocompleteWrapper>
      </div>
      <div style={{ display: 'flex', gap: 10 }}>
        {/* DO NOT DELETE */}
        <ImportButton
          data-id="import-patients-dialog"
          disabled={isINS}
          onClick={openImportPaitentDialog}
        />
        {getPermission('PATIENTS_MANAGEMENT', 'create') && (
          <NewPatientButton
            data-id="new-patient-button"
            onClick={openNewPatientDialog}
          />
        )}
      </div>
    </SContainer>
  );
}
